import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import ddData from '../../data/divyadesams.json';

const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };

/* Build photo map from file listing */
const photoMap = {};
const photoFiles = [
  '001-srirangam','002-woraiyur','003-thanjavur','004-anbil','005-uththamarkoil',
  '006-thiruvellarai','007-pullabhoodankudi','008-koiladi','009-aadhanur','010-thiruvazhundhur',
  '011-sirupuliyur','012-thirucherai','013-thalaichangadu','014-kumbakonam','015-kandiyur',
  '016-opiliyappan','017-thirukkannapuram','018-tiruvali-tirunagari','019-nagai','020-nachiyarkoil',
  '021-naathankoil','022-indalur','023-chithirakudam','024-Kazhichirama-Vinagaram','025-kudalur',
  '026-kannangudi','027-kannamangai','028-kavithalam','029-velliyangudi','030-manimadakoil',
  '031-vaikundavinnagaram','032-arimeyavinnagaram','033-thevanarthogai','034-vanpurudothamam',
  '035-semponseikoil','036-thetriambalam','037-manikkudam','038-kavalampadi','039-vellakulam',
  '040-parthanpalli','041-malirunsolai','042-koshtiyur','043-meiyam','044-pullani','045-thankal',
  '046-mogur','047-kudal','048-villiputhur','049-kurugur','050-tholaivillimangalam',
  '051-srivaramangai','052-pulingudi','053-perai','054-vaikundam','055-varagunamangai',
  '056-kulandai','057-kurungudi','058-kolur','059-vanandapuram','060-vanparisaram',
  '061-katkarai','062-muzhikalam','063-thirupuliyur','064-thiruchenkundrur','065-thirunavai',
  '067-thiruvanvandur','068-thiruvattaru','069-thiruviththuvakkodu','070-thirukkadithanam',
  '071-thiruvaranvilai','072-thiruvendhipuram','073-thirukkovilur','074-thirukkachi',
  '075-ashtapuyakaram','076-thiruththanka','077-thiruvelukkai','078-thiruppadagam',
  '079-thiruneeragam','080-thirunilathingal','081-thiruvooragam','082-thiruvekha',
  '083-thirukkaragam','084-thirukkarvaanam','085-thirukkalvanur','086-thirupavalavannam',
  '087-parameswaravinnagaram','088-thiruputkuzhi','089-thirunindravoor','090-thiruvallur',
  '091-thiruneermalai','092-thiruvidavendhai','093-thirukkadanmallai','094-thiruvallikeni',
  '095-sholingar','096-thiruvengadam','097-ahobilam','098-thiruvayothi','099-naimisaranyam',
  '100-salagramam','101-padarikashramam','102-kandangkadinagar','103-thirupiridhi',
  '104-thirudwaragai','105-vadamadhurai','106-thiruvaipadi','107-thiruparkadal','108-paramapadham'
];
photoFiles.forEach(f => {
  const num = parseInt(f.split('-')[0], 10);
  photoMap[num] = `/dd-photos/${f}.jpg`;
});

/* 5 different temple frame designs with their image-opening positions */
const FRAMES = [
  { src: '/dd-photos/frame-gold.png',   top: '20%', left: '22%', width: '56%', height: '55%' },
  { src: '/dd-photos/frame-silver.png', top: '20%', left: '20%', width: '60%', height: '54%' },
  { src: '/dd-photos/frame-wood.png',   top: '18%', left: '20%', width: '60%', height: '56%' },
  { src: '/dd-photos/frame-bronze.png', top: '18%', left: '22%', width: '56%', height: '56%' },
  { src: '/dd-photos/frame-stone.png',  top: '18%', left: '18%', width: '64%', height: '58%' },
];

/* Temple Sanctum Frame - cycles through 5 frame designs */
const TempleSanctum = ({ imageSrc, title, number }) => {
  if (!imageSrc) return null;
  const frame = FRAMES[(number - 1) % FRAMES.length];
  return (
    <div style={{
      margin: '0 auto 16px',
      maxWidth: '400px',
      position: 'relative',
    }}>
      <div style={{ position: 'relative', width: '100%' }}>
        {/* Layer 1: The sanctum frame image (base) */}
        <img
          src={frame.src}
          alt="Temple Sanctum"
          style={{
            width: '100%',
            display: 'block',
            borderRadius: '6px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.5)',
          }}
        />

        {/* Layer 2: Temple photo placed ON TOP, inside the frame opening */}
        <div style={{
          position: 'absolute',
          top: frame.top,
          left: frame.left,
          width: frame.width,
          height: frame.height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}>
          <img
            src={imageSrc}
            alt={title}
            loading="lazy"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'top',
              borderRadius: '2px',
            }}
          />
        </div>
      </div>

      <div style={{
        textAlign: 'center',
        marginTop: '8px',
        fontSize: '0.7rem',
        color: '#8B4513',
        fontWeight: 600,
        letterSpacing: '2px',
      }}>
        🪔 மூலஸ்தானம் 🪔
      </div>
    </div>
  );
};

/* Horizontally scrollable quick-nav numbered bubbles */
const QuickNav = ({ currentSlug }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      const active = scrollRef.current.querySelector('[data-active="true"]');
      if (active) {
        active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }
  }, [currentSlug]);

  return (
    <div
      ref={scrollRef}
      className="quick-nav-wrap"
      style={{
        display: 'flex',
        gap: '4px',
        overflowX: 'auto',
        padding: '8px 4px',
        marginBottom: '10px',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
    >
      <style>{`.quick-nav-wrap::-webkit-scrollbar { display: none; }`}</style>
      {ddData.map(item => {
        const itemSlug = item.seoSlug || item.slug;
        const isActive = itemSlug === currentSlug || item.slug === currentSlug || item.id === currentSlug;
        return (
          <Link
            key={item.id || item.slug}
            to={`/divyadesams/${itemSlug}`}
            data-active={isActive ? 'true' : 'false'}
            title={item.title}
            style={{
              flexShrink: 0,
              padding: '3px 8px',
              borderRadius: '12px',
              fontSize: '0.6rem',
              fontWeight: isActive ? 700 : 500,
              textDecoration: 'none',
              whiteSpace: 'nowrap',
              background: isActive ? T.greenDk : '#fff',
              color: isActive ? '#fff' : T.maroon,
              border: `1px solid ${isActive ? T.greenDk : T.border}`,
              boxShadow: isActive ? '0 2px 4px rgba(0,0,0,0.15)' : '0 1px 2px rgba(0,0,0,0.06)',
              transition: 'all 0.2s ease',
              minWidth: '28px',
              textAlign: 'center',
            }}
          >
            {item.number}
          </Link>
        );
      })}
    </div>
  );
};

/* Index page: grid of all 108 temples */
const DivyadesamsIndex = () => {
  useEffect(() => {
    document.title = "108 திவ்ய தேசங்கள் - 108 Divya Desams Directory | Ahobilam";
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", "https://ahobilam.com/divyadesams");
  }, []);

  return (
    <div style={{background:T.bg, minHeight:'80vh', padding:'15px', fontFamily:'sans-serif'}}>
      <div style={{background:T.header, padding:'15px', borderRadius:'10px', textAlign:'center', marginBottom:'10px', boxShadow:'0 4px 6px rgba(0,0,0,0.1)'}}>
        <h1 style={{color:'#fff', margin:0, fontSize:'1.2rem', fontWeight:900}}>🏛️ 108 திவ்ய தேசங்கள்</h1>
        <div style={{color:'#c8e6c9', fontSize:'0.8rem'}}>108 Divya Desams - Complete Guide & Details</div>
      </div>

      <QuickNav currentSlug="" />

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
        gap: '8px',
      }}>
        {ddData.map(item => {
          const itemSlug = item.seoSlug || item.slug;
          return (
            <Link
              key={item.id || item.slug}
              to={`/divyadesams/${itemSlug}`}
              style={{
                textDecoration: 'none',
                background: T.cream,
                border: `1px solid ${T.border}`,
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                transition: 'box-shadow 0.2s',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {photoMap[item.number] && (
                <img
                  src={photoMap[item.number]}
                  alt={item.title}
                  style={{ width:'100%', height:'90px', objectFit:'cover' }}
                  loading="lazy"
                />
              )}
              <div style={{ padding:'8px', display:'flex', alignItems:'center', gap:'6px' }}>
                <span style={{
                  background: T.greenDk, color:'#fff', borderRadius:'50%',
                  width:'24px', height:'24px', display:'flex', alignItems:'center',
                  justifyContent:'center', fontSize:'0.6rem', fontWeight:700, flexShrink:0,
                }}>
                  {item.number}
                </span>
                <span style={{
                  color: T.maroon, fontWeight:600, fontSize:'0.7rem', lineHeight:1.3,
                }}>
                  {item.title}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

/* Detail page: individual Divyadesam */
const DivyadesamsDetailPage = () => {
  const params = useParams();
  const activeSlug = params.slug || params.id;
  const [content, setContent] = useState(null);

  useEffect(() => {
    if (activeSlug) {
      const found = ddData.find(d => 
        d.seoSlug === activeSlug ||
        d.slug === activeSlug || 
        d.id === activeSlug || 
        d.number === parseInt(activeSlug.replace(/\D/g, ''), 10)
      );
      setContent(found || null);
    } else {
      setContent(null);
    }
  }, [activeSlug]);

  useEffect(() => {
    if (content) {
      const preferredSlug = content.seoSlug || content.slug;
      const titleText = `${content.title} - 108 Divya Desam #${content.number} | Ahobilam`;
      document.title = titleText;

      // Canonical link update
      let canonical = document.querySelector("link[rel='canonical']");
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", `https://ahobilam.com/divyadesams/${preferredSlug}`);

      // Meta Description update
      let metaDesc = document.querySelector("meta[name='description']");
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.setAttribute("name", "description");
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute("content", `${content.title} (108 Divya Desam #${content.number}) full details, sthala puranam, moorrti, thirtham, mangalasasanam and location.`);

      // Schema.org JSON-LD update
      let scriptTag = document.getElementById("temple-schema");
      if (!scriptTag) {
        scriptTag = document.createElement("script");
        scriptTag.id = "temple-schema";
        scriptTag.type = "application/ld+json";
        document.head.appendChild(scriptTag);
      }
      const schemaData = {
        "@context": "https://schema.org",
        "@type": "HinduTemple",
        "name": content.title,
        "url": `https://ahobilam.com/divyadesams/${preferredSlug}`,
        "description": `${content.title} sthala puranam and 108 Divya Desams temple details.`
      };
      scriptTag.text = JSON.stringify(schemaData);
    }
  }, [content]);

  if (!activeSlug || !content) {
    return <DivyadesamsIndex />;
  }

  const imgSrc = photoMap[content.number] || null;
  const prevItem = content.number > 1 ? ddData.find(d => d.number === content.number - 1) : null;
  const nextItem = content.number < 108 ? ddData.find(d => d.number === content.number + 1) : null;

  return (
    <div style={{background:T.bg, minHeight:'80vh', padding:'15px', fontFamily:'sans-serif'}}>
      <div style={{background:T.header, padding:'15px', borderRadius:'10px', textAlign:'center', marginBottom:'4px', boxShadow:'0 4px 6px rgba(0,0,0,0.1)'}}>
        <div style={{color:'#c8e6c9', fontSize:'0.7rem', marginBottom:'4px'}}>
          திவ்ய தேசம் #{content.number}
        </div>
        <h1 style={{color:'#fff', margin:0, fontSize:'1.2rem', fontWeight:900}}>{content.title}</h1>
      </div>

      <QuickNav currentSlug={activeSlug} />

      {/* Temple Sanctum Image */}
      <TempleSanctum imageSrc={imgSrc} title={content.title} number={content.number} />

      <div
        className="dd-page"
        style={{
          background: T.cream,
          padding: '20px',
          borderRadius: '10px',
          border: `1px solid ${T.border}`,
          color: '#333',
          lineHeight: '1.8',
          boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
          fontFamily: "'Noto Sans Tamil', 'Latha', 'Nirmala UI', sans-serif",
        }}
        dangerouslySetInnerHTML={{ __html: content.contentHtml }}
      />

      <style>{`
        .dd-page .dd-line { margin: 0 0 4px 0; font-size: 0.85rem; }
        .dd-page .dd-line.dd-label { color: #cc0000; font-weight: 600; margin-top: 10px; }
        .dd-page .dd-line.dd-value { color: #000099; margin-bottom: 6px; }
        .dd-page .dd-line.dd-empty { height: 0.5em; }
      `}</style>

      <div style={{marginTop:'20px', textAlign:'center', display:'flex', gap:'10px', justifyContent:'center', flexWrap:'wrap'}}>
        {prevItem && (
          <Link
            to={`/divyadesams/${prevItem.seoSlug || prevItem.slug}`}
            style={{
              display:'inline-block', padding:'8px 16px', background:'#fff',
              color:T.greenDk, textDecoration:'none', borderRadius:'20px',
              fontSize:'0.8rem', fontWeight:'bold', border:`1px solid ${T.greenDk}`
            }}
          >
            ← Prev
          </Link>
        )}
        <Link
          to="/divyadesams"
          style={{
            display:'inline-block', padding:'8px 16px', background:T.greenDk,
            color:'#fff', textDecoration:'none', borderRadius:'20px',
            fontSize:'0.8rem', fontWeight:'bold'
          }}
        >
          All 108
        </Link>
        {nextItem && (
          <Link
            to={`/divyadesams/${nextItem.seoSlug || nextItem.slug}`}
            style={{
              display:'inline-block', padding:'8px 16px', background:'#fff',
              color:T.greenDk, textDecoration:'none', borderRadius:'20px',
              fontSize:'0.8rem', fontWeight:'bold', border:`1px solid ${T.greenDk}`
            }}
          >
            Next →
          </Link>
        )}
      </div>
    </div>
  );
};

export default DivyadesamsDetailPage;
